import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMemo } from 'react';
import { isDark } from '../common/utils';
import styles from './text.module.scss';
const Text = ({ size = 'sm', RTL = false, children, }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const textClass = useMemo(() => classNames({
        [styles[size]]: true,
    }, RTL ? styles.RTL : '', styles.container, isDarkMode ? styles.dark : ''), []);
    return _jsx("p", { className: textClass, children: children });
};
export { Text };
